import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

// const IMAGE_URL = "https://www.acrisure.com/_next/image?url=https%3A%2F%2Fedge.sitecorecloud.io%2Facrisurellc1-acrisure-prod-0dbe%2Fmedia%2FProject%2FAcrisure%2FAcrisure-Site%2FMaster-Site%2FPages%2FWhy-Acrisure%2FPromo-full.png%3Fh%3D978%26iar%3D0%26w%3D1792&w=3840&q=75";

function Contacts() {
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    name: '',
    type: '',
    email: '',
    phone: '',
    message: '',
  });

  const isFormEmpty = !form.name && !form.type && !form.email && !form.phone && !form.message;

  const handleToggle = () => {
    if (open && !isFormEmpty) return;
    setOpen(!open);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Name is required.';
    if (!form.type) newErrors.type = 'Please select Business or Private Client.';
    if (!form.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }
    if (!form.phone.trim()) newErrors.phone = 'Contact number is required.';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setSending(true);
  try {
  const templateParams = {
    from_name: form.name,
    client_type: form.type,
    from_email: form.email,
    phone: form.phone,
    message: form.message || 'No message provided.',
    to_email: 'admin@redoura.com',
    time: new Date().toLocaleString('en-US', {
      timeZone: 'Asia/Jakarta',
      dateStyle: 'medium',
      timeStyle: 'short',
    }),
  };

  // Send to admin
  await emailjs.send(
    'service_twwyquo',
    'template_m6wgqvo',
    templateParams,
    'FvNSGOeU1uqVAOr8Z'
  );

  // Auto-reply to sender
  await emailjs.send(
    'service_twwyquo',
    'template_w99ubyp',
    templateParams,
    'FvNSGOeU1uqVAOr8Z'
  );

    setSent(true);
    setForm({ name: '', type: '', email: '', phone: '', message: '' });
    setErrors({});
    setTimeout(() => {
      setSent(false);
      setOpen(false);
    }, 3000);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
    setSending(false);
  };

  return (
    <section className="relative py-20 px-4 overflow-hidden">

      <img src='/image/bg-contact2.jpg' alt="Background" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#0e1e52]/35" />

      <div className="relative z-10 max-w-7xl mx-auto text-center">

        {/* Tags */}
        {/* <div className="flex flex-wrap justify-center gap-3 mb-8">
          {['Risk & Insurance', 'Employee Benefits', 'Retirement & Private Wealth'].map((tag, i) => (
            <span key={i} className="border border-white/30 text-white/70 text-xs uppercase tracking-widest px-4 py-2 rounded-full">
              {tag}
            </span>
          ))}
        </div> */}

        <p className="text-white text-lg text-center uppercase tracking-widest mb-10">
          Protect What Matters Most
        </p>

        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-8">
          <span className="text-[#ce381b]">Free Consultation</span> With Our Expert
        </h2>

        {/* Toggle Button */}
        <button
          onClick={handleToggle}
          className="inline-flex items-center gap-2 bg-[#ce381b] hover:bg-red-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition duration-300"
        >
          {open ? 'Close' : 'Consult Now'}
          <svg className={`w-5 h-5 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Expandable form wrapper — bigger cap so the open/close animation never clips content */}
        <div className={`overflow-hidden transition-all duration-500 ease-in-out ${open ? 'max-h-[2000px] mt-8' : 'max-h-0'}`}>

          {/* Scrollable card — this is what actually caps the visible height on small screens */}
          <form
            onSubmit={handleSubmit}
            className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 max-w-xl mx-auto text-left max-h-[80vh] overflow-y-auto contact-form-scroll"
          >

            {/* Success message */}
            {sent && (
              <div className="bg-green-500/20 border border-green-500/40 text-green-300 rounded-lg px-4 py-3 mb-6 text-center">
                ✅ Message sent successfully! We'll be in touch soon.
              </div>
            )}

            {/* Name */}
            <div className="mb-4">
              <label className="text-white/70 text-sm uppercase tracking-widest block mb-2">Name <span className="text-red-400">*</span></label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your full name"
                className={`w-full bg-white/10 border text-white placeholder-white/40 rounded-lg px-4 py-3 focus:outline-none transition ${errors.name ? 'border-red-500' : 'border-white/20 focus:border-red-500'}`}
              />
              {errors.name && <p className="text-red-400 text-xs mt-1">{errors.name}</p>}
            </div>

            {/* Type */}
            <div className="mb-4">
              <label className="text-white/70 text-sm uppercase tracking-widest block mb-2">Are you a <span className="text-red-400">*</span></label>
              <div className="flex gap-4">
                {['Business', 'Private Client'].map((option) => (
                  <button
                    key={option}
                    type="button"
                    onClick={() => { setForm({ ...form, type: option }); setErrors({ ...errors, type: '' }); }}
                    className={`flex-1 py-3 rounded-lg border text-sm font-semibold transition duration-300 ${
                      form.type === option
                        ? 'bg-red-600 border-red-600 text-white'
                        : 'bg-white/10 border-white/20 text-white/70 hover:border-white/50'
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
              {errors.type && <p className="text-red-400 text-xs mt-1">{errors.type}</p>}
            </div>

            {/* Email */}
            <div className="mb-4">
              <label className="text-white/70 text-sm uppercase tracking-widest block mb-2">Your Email <span className="text-red-400">*</span></label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="your@email.com"
                className={`w-full bg-white/10 border text-white placeholder-white/40 rounded-lg px-4 py-3 focus:outline-none transition ${errors.email ? 'border-red-500' : 'border-white/20 focus:border-red-500'}`}
              />
              {errors.email && <p className="text-red-400 text-xs mt-1">{errors.email}</p>}
            </div>

            {/* Phone */}
            <div className="mb-4">
              <label className="text-white/70 text-sm uppercase tracking-widest block mb-2">Contact Number <span className="text-red-400">*</span></label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+62 xxx xxxx xxxx"
                className={`w-full bg-white/10 border text-white placeholder-white/40 rounded-lg px-4 py-3 focus:outline-none transition ${errors.phone ? 'border-red-500' : 'border-white/20 focus:border-red-500'}`}
              />
              {errors.phone && <p className="text-red-400 text-xs mt-1">{errors.phone}</p>}
            </div>

            {/* Message */}
            <div className="mb-6">
              <label className="text-white/70 text-sm uppercase tracking-widest block mb-2">Ask us anything <span className="text-white/30 text-xs normal-case">(optional)</span></label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Type your question or message here..."
                rows={4}
                className="w-full bg-white/10 border border-white/20 text-white placeholder-white/40 rounded-lg px-4 py-3 focus:outline-none focus:border-red-500 transition resize-none"
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={sending}
              className="w-full bg-[#ce381b] hover:bg-red-500 disabled:bg-red-800 text-white py-4 rounded-lg font-semibold text-lg transition duration-300"
            >
              {sending ? 'Sending...' : 'Submit'}
            </button>

            {!isFormEmpty && (
              <p className="text-white/50 text-xs text-center mt-4">
                ⚠️ Your form has unsaved content. Complete and submit before closing.
              </p>
            )}

          </form>
        </div>

        <style jsx>{`
          .contact-form-scroll::-webkit-scrollbar {
            width: 6px;
          }
          .contact-form-scroll::-webkit-scrollbar-track {
            background: transparent;
          }
          .contact-form-scroll::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 999px;
          }
          .contact-form-scroll::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.35);
          }
        `}</style>

      </div>
    </section>
  );
}

export default Contacts;